module.exports = __webpack_public_path__ + "img/staking-info.a1756243.svg";